import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEmployeeStatsApi } from '../Utils/Axios';

// Async thunk to fetch employee stats for dashboard
export const fetchEmployeeStats = createAsyncThunk(
  'employeeStats/fetchEmployeeStats',
  async ({ companyName, branchId, year }, { rejectWithValue }) => {
    try {
      const response = await getEmployeeStatsApi(companyName, branchId, year);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch employee stats'
      );
    }
  }
);

// Slice
const employeeStatsSlice = createSlice({
    name: 'employeeStats',
    initialState: {
        data: { total: 0, active: 0, relieved: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearEmployeeStats: (state) => {
            state.data = { total: 0, active: 0, relieved: 0 };
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployeeStats.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmployeeStats.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchEmployeeStats.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearEmployeeStats } = employeeStatsSlice.actions;
export default employeeStatsSlice.reducer;
